<template>
  <b-modal
    id="action-report-modal"
    ref="actionReportModal"
    modal-class="action-report-modal"
    centered
    :hide-header-close="true" >
    <template slot="modal-title">
      <b>{{ actionData.title.value }}</b> {{ actionData.title.text }}
    </template>
    <div>
      <div
        v-for="(item, index) in actionData.items"
        :key="index"
        class="item flex center-all"
        :class="{ 'main-stat': item.level === 0, 'sub-stat': item.level === 1 }" >
        <div class="icon-wrapper">
          <SBIcon
            v-if="item.icon"
            style="margin-top: 1px;"
            :icon="item.icon"
            :color="item.iconColor || '#7C8B91'"
            :size="item.iconSize || 12"/>
        </div>
        <span>{{ item.title }}</span>
        <template v-if="item.info">
          <SBIcon
            :id="`popover-${index}`"
            class="info-icon no-shrink ml-1"
            :icon="SBIconList.INFORMATION"
            :color="SBColors.greyPrimary"
            :size="10" />
          <b-popover
            :target="`popover-${index}`"
            custom-class="blue-href"
            triggers="hover"
            boundary="window"
            placement="top"
            no-fade
            :delay="{ show: 0, hide: 100 } " >
            <h1>{{ item.info.title }}</h1>
            <p :inner-html.prop="item.info.text" />
          </b-popover>
        </template>
        <span class="greedy dashes" />
        <span>{{ (item.value) | bigDigits }}</span>
      </div>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'ActionReportModal',
  components: {
    SBIcon,
  },
  props: {
    actionData: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
    };
  },
  computed: {},
  methods: {
    show() {
      this.$refs.actionReportModal.show();
    },
    hide() {
      this.$refs.actionReportModal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .modal-header {
      h5 {
        font-weight: 400 !important;
      }
    }

    .modal-body {
      background-color: $white !important;
    }
  }

  div.item {
    * {
      font-size: 14px;
    }
    .icon-wrapper {
      width: 22px;
      height: 100%;
    }
    &.main-stat {
      color: $blackPrimary;
      span:last-of-type {
        font-weight: 500;
      }

      &:not(:first-of-type) {
        margin-top: 22px;
      }
    }

    &.sub-stat {
      margin-top: 8px;
      color: $greyPrimary;

      span:first-of-type {
        text-transform: capitalize;
      }
    }

    span.dashes {
      margin: 10px 10px 0;
      border-bottom: 1px dashed #dde6e9;
    }
  }
</style>
